<div class="donut-wrap">
    <div class="donut-canvas-box">
        <canvas #canvas></canvas>
        <div class="donut-center">
            <p class="donut-center-value">{{formatCurrency(total)}}</p>
            <p class="donut-center-label">Total</p>
        </div>
    </div>
    <ul class="donut-legend">
        <li *ngFor="let slice of slices; let i = index">
            <span class="donut-legend-dot" [style.background]="color(i)"></span>
            <span class="donut-legend-name">{{slice.name}}</span>
            <span class="donut-legend-pct">{{slice.percentage}}%</span>
            <span class="donut-legend-amount">{{formatCurrency(slice.amount)}}</span>
        </li>
    </ul>
</div>
